/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {firstValueFrom, Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './team-object-membership-modal.component.html';
import {AdnModalLoadingService} from '../../common/util/adn-modal-loading.service';

@Component({
  standalone: false,
  selector: 'adn-team-object-membership-modal',
  template
})
export class TeamObjectMembershipModalComponent implements OnInit {
  theResource: any;
  translation = '';
  obj: any;
  objects: any[] = [];
  matchedObjects: any[] = [];

  readonly onSaved = new Subject<void>();

  objectsCopy: any[] = [];
  selectedObjectIds: string[] = [];
  validationErrors: any[] = [];
  disabled = false;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.objectsCopy = _.cloneDeep(this.objects || []);
    this.selectedObjectIds = _.map(this.matchedObjects || [], 'id');
  }

  get translationLower(): string {
    return (this.translation || '').toLowerCase();
  }

  selectObjects(): void {
    this.selectedObjectIds = _.map(this.objectsCopy, 'id');
  }

  deselectObjects(): void {
    this.selectedObjectIds = [];
  }

  isSelected(objectId: string): boolean {
    return this.selectedObjectIds.indexOf(objectId) > -1;
  }

  toggleObject(objectId: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const selected = [...this.selectedObjectIds];
    const index = selected.indexOf(objectId);
    if (checked && index < 0) {
      selected.push(objectId);
    } else if (!checked && index > -1) {
      selected.splice(index, 1);
    }
    this.selectedObjectIds = selected;
  }

  trackByObjectId(_index: number, object: any): string {
    return object.id;
  }

  saveAndClose(): void {
    this.disabled = true;
    this.adnModalLoading.applyModalLoading();

    _.forEach(this.objectsCopy, (object: any) => {
      object.removeTeams = object.removeTeams || [];
      const wantsToBeInTeam = this.selectedObjectIds.indexOf(object.id) > -1;
      if (wantsToBeInTeam) {
        object.teams.push(this.obj);
        object.hasChanged = true;
      }
      if (!wantsToBeInTeam) {
        object.teams = _.filter(object.teams, (team: any) => team.id !== this.obj.id);
        object.removeTeams.push(this.obj);
        object.hasChanged = true;
      }
    });

    const changedObjects = _.map(_.filter(this.objectsCopy, (object: any) => object.hasChanged), (object: any) => {
      return _.pick(object, 'id', 'teams', 'removeTeams');
    });

    const savePromise = firstValueFrom(this.theResource.saveMany(changedObjects));
    savePromise.then(() => {
      this.disabled = false;
      this.onSaved.next();
      this.adnModalLoading.removeModalLoading();
      this.bsModalRef.hide();
    }, (errors: any) => {
      this.disabled = false;
      this.validationErrors = _.get(errors, ['data', 'errors'], []);
      this.adnModalLoading.removeModalLoading();
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
